<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="550"
  >
    <validation-observer
      ref="observer"
    >
      <v-card>
        <v-card-title>
          ドライバー選択
        </v-card-title>
        <v-divider />
        <v-card-text
          v-if="drivers"
          class="pt-3"
        >
          <validation-provider
            v-slot="{ errors }"
            class="requiredMark"
            name="ドライバー"
            rules="required"
          >
            <v-select
              v-model="forms.selectedDriver"
              :items="drivers"
              :error-messages="errors"
              clearable
              label="ドライバー"
              hide-details="auto"
              outlined
              persistent-placeholder
              placeholder="未選択"
            >
              <!-- 選択状態 -->
              <template v-slot:selection="{ item }">
                <v-avatar
                  color="primary"
                  size="40"
                >
                  <v-img
                    v-if="item.avatar"
                    :alt="`${item.text} avatar`"
                    :src="item.avatar | load_image_url"
                  />
                  <span v-else class="primary white--text">
                    {{ item.text.slice(0, 2) }}
                  </span>
                </v-avatar>
                &nbsp;{{ item.text }}
              </template>
              <!-- /選択状態 -->
              <!-- 一覧 -->
              <template v-slot:item="{ item }">
                <v-avatar
                  color="primary"
                  size="40"
                >
                  <v-img
                    v-if="item.avatar"
                    :alt="`${item.text} avatar`"
                    :src="item.avatar | load_image_url"
                  />
                  <span v-else class="primary white--text">
                    {{ item.text.slice(0, 2) }}
                  </span>
                </v-avatar>
                &nbsp;<span>{{ item.text }}</span>
              </template>
              <!-- /一覧 -->
            </v-select>
          </validation-provider>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            @click="registerButtonClickEvent"
          >
            変更
          </v-btn>
        </v-card-actions>
    </v-card>
    </validation-observer>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AllocationPlanSelectDriverDialog',
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    targetDriverId: {
      type: Number,
      default: () => null
    },
  },
  data() {
    return {
      forms: {
        selectedDriver: null,
      },
      drivers: [],
    }
  },
  computed: {},
  watch: {
    enableDialog (newVal) {
      this.$nextTick(() => this.$refs.observer.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);
      this.selectedDriver = null
      this.drivers = []
      if (newVal) {
        this.setVariable()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverMasterSearchDriver', {
      fetchDrivers: 'index',
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    /**
     * 変更するボタン クリックイベント
     */
    registerButtonClickEvent () {
      let $self = this
      this.$refs.observer.validate().then((result) => {
        if(result){
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation(){
      this.$emit('registerEvent', this.targetDriverId, this.forms.selectedDriver)
    },
    /**
     * 画面情報を設定
     */
    setVariable () {
      this.fetchDrivers({without_invisible: true}).then((content) => {
        // 親画面から渡されたユーザーを除く
        this.drivers = content.drivers.filter( driver => driver.value !== this.targetDriverId)
      })
    }
  }
}
</script>
